import Vue from 'vue'
import VueResource from 'vue-resource'
Vue.use(VueResource)

export default new Vue({
  methods: {
    getProductsInCategory (categoryId, callback) {
      const endpoint = new URL(client_configuration.ajax_url)
      endpoint.searchParams.append('action', 'category_products_json')
      endpoint.searchParams.append('filter[category_id]', categoryId)

      this.$http.get(endpoint.href).then(response => {
        callback(response.body)
      }, response => {
        // error callback
      })
    },
    getStoresForProduct (location, productId, callback) {
      const endpoint = new URL(client_configuration.ajax_url)
      endpoint.searchParams.append('action', 'stores_near')
      endpoint.searchParams.append('filter[latitude]', location.latitude)
      endpoint.searchParams.append('filter[longitude]', location.longitude)
      endpoint.searchParams.append('filter[product_id]', productId)

      this.$http.get(endpoint.href).then(response => {
        callback(response.body)
      }, response => {
        // error callback
      });
    },
    getStores (location, callback) {
      const endpoint = new URL(client_configuration.ajax_url)
      endpoint.searchParams.append('action', 'stores_near')
      endpoint.searchParams.append('filter[latitude]', location.latitude)
      endpoint.searchParams.append('filter[longitude]', location.longitude)

      this.$http.get(endpoint.href).then(response => {
        callback(response.body)
      }, response => {
        // error callback
      });
    },
  }
})
